/**
 * Retrieves a storage provider or null if the local storage is disabled or not supported in the platform
 *
 * @returns A storage provider or null
 */
export function getStorgeProvider() {
    let provider = null;
    try {
        if (window.localStorage) {
            provider = {
                get: key => window.localStorage.getItem(key),
                set: (key, value) => window.localStorage.setItem(key, value),
                remove: key => window.localStorage.removeItem(key),
                clear: () => window.localStorage.clear(),
            };
        }
    }
    catch (e) {
        // The local storage is disabled or not supported in the platform.
    }
    return provider;
}
